import { type LucideIcon, BookOpen } from 'lucide-react';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  message?: string;
  children?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  icon: Icon = BookOpen,
  title,
  message,
  children,
  className = '',
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}
      role="status"
      aria-label={title}
    >
      <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center mb-4">
        <Icon className="w-7 h-7 text-muted-foreground" />
      </div>
      <p className="text-foreground font-medium">{title}</p>
      {message && <p className="text-muted-foreground text-sm mt-1 max-w-sm">{message}</p>}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}
